// i18next-extract-disable

import React from 'react';
import { Trans } from 'react-i18next';

import { t } from 'localization/utils/t';

const isObject = (value) =>
  typeof value === 'object' &&
  value?.constructor === Object &&
  value !== null &&
  !Array.isArray(value);

const isArray = (value) => Array.isArray(value);

const shouldTranslate = (value) => value?.value && value?.TK && value?.TP;

const isTransObject = (value) => shouldTranslate(value) && value?.components;

export const translateKey = (constant) => {
  const { value, TK, TP } = constant || {};
  return t(`${TP as string}.${TK as string}`, value);
};

export const translateTrans = (constant) => {
  const { value, TK, TP, components } = constant || {};
  return (
    <Trans
      i18nKey={`${TP as string}.${TK as string}`}
      defaults={value as string}
      components={components}
    />
  );
};

export const translateObject = (object: { [key: string]: any } = {}) => {
  /*
  plain string:

  const PAGE_DESCRIPTION = {
    value: 'sample description',
    TK: 'goatCleanPageDescription',
    TP,
  }
  */
  if (isObject(object) && shouldTranslate(object)) {
    return translateKey(object);
  }

  /*
  Trans component:

  const TRANS = {
    value: 'sample description. <0>Goat Clean</0> <1>Homepage</1>',
    TK: 'goatCleanPageDescription',
    TP,
    components: [
      <a href="/goat-clean" />,
      <a href="/home" />,
    ]
  }
  */
  if (isObject(object) && isTransObject(object)) {
    return translateTrans(object);
  }

  /*
  For nested objects:
  
  const PaymentVendorNameMap = {
    [PaymentVendor.Affirm]: { defaultValue: 'Affirm', TK: 'Affirm', TP },
    [PaymentVendor.AfterPay]: { defaultValue: 'AfterPay', TK: 'AfterPay', TP },
    [PaymentVendor.AliPay]: { defaultValue: 'AliPay', TK: 'AliPay', TP },
    [PaymentVendor.ApplePay]: { defaultValue: 'ApplePay', TK: 'ApplePay', TP },
    [PaymentVendor.CreditCard]: { defaultValue: 'CreditCard', TK: 'CreditCard', TP },
    [PaymentVendor.Giropay]: { defaultValue: 'Giropay', TK: 'Giropay', TP },
    [PaymentVendor.Klarna]: { defaultValue: 'Klarna', TK: 'Klarna', TP },
    [PaymentVendor.PayPal]: { defaultValue: 'PayPal', TK: 'PayPal', TP },
  };
  */
  for (const key of Object.keys(object)) {
    const valueOfKey = object[key];

    // child nested array
    if (isArray(valueOfKey)) {
      object[key] = object[key]?.map((subItem) => {
        if (isObject(subItem)) {
          return translateObject(subItem);
        }
        return subItem;
      });
    }

    // child nested object
    if (isObject(valueOfKey)) {
      object[key] = translateObject(valueOfKey);
    }
  }

  return object;
};

export const translateArray = (list = []) => {
  const result = list?.map((item) => {
    if (isObject(item)) {
      return translateObject(item);
    }
    if (isArray(item)) {
      return translateArray(item);
    }
    return item;
  });
  return result;
};

export const getTranslations = (data) => {
  if (isArray(data)) {
    return translateArray(data);
  }

  if (isObject(data)) {
    return translateObject(data);
  }
};
